import { useEffect, useState } from "react";
import { BeatLoader } from "react-spinners";
import { styled } from "styled-components";
import { theme } from "../configs/theme";
import api, { GetProfileData } from "../services/api";
import { useUserStore } from "../store/useUserStore";
import { MainContainer } from "../styles/Container.style";
import { Paragraph, Title } from "../styles/Text";
import { Column, Gap, Row } from "../styles/Utils";
import { MoreButton } from "./MoreButton.component.tsx";
import { QuestionsView } from "./QuestionsView.component.tsx";
import Slider from "./Slider.component";
import StatusBadge from "./StatusBadge.component";
import LocationIcon from "./svgs/icons/Location.icon";
import { StatutBadgeContainer } from "./Swiper.component";

interface ProfileViewProps {
  profileId: string;
}

export default function ProfileView({ profileId }: ProfileViewProps) {
  const {
    profile: { isKmUnit },
    setDogNameOnTopNavBar,
  } = useUserStore();
  const [profile, setProfile] = useState<GetProfileData>();
  const [isMoreInfosOpened, setIsMoreInfosOpened] = useState(false);

  useEffect(() => {
    (async function () {
      try {
        const res = await api.getProfileView(profileId);
        const profile = res.data;
        setProfile(profile);
        setDogNameOnTopNavBar(profile.dogName);
      } catch (err) {
        console.log("Error fetching specific profile", err);
        alert("Error fetching specific profile");
      }
    })();
  }, []);

  if (!profile) {
    return (
      <Column $alignItem="center" $justifyContent="flex-start" $maxHeight>
        <Gap $height={5} />
        <Row $justifyContent="center">
          <BeatLoader color={theme.color.primaryDark} />
        </Row>
      </Column>
    );
  }

  const questions = profile.questions.filter((e) => e.enabled && e.answer != "");
  const distanceFromProfile = profile.distance
    ? Math.floor(isKmUnit ? profile.distance / 1000 : profile.distance / 1600)
    : null;
  return (
    <Column key={profile.email + profile.dogName} $alignItem="center" $maxHeight>
      <Title>{profile.traits.join("-")}</Title>
      <div style={{ width: "100%" }}>
        <MainContainerOvl $padding="1rem">
          <Slider relativeSizing isOverflowHidden buttonColor={theme.color.primary}>
            {profile.imageUrls.map((img) => (
              <Image key={img} src={img} onClick={() => setIsMoreInfosOpened(true)} />
            ))}
          </Slider>
          <Gap $height={1} />
          <LocationIcon size={3} color={theme.color.primaryDark} />
          <Gap $height={0.5} />
          <Paragraph>
            {distanceFromProfile ?? "Unknown"} {isKmUnit ? "km" : "miles"} away
          </Paragraph>
          {profile.accountVerified && (
            <StatutBadgeContainer>
              <StatusBadge />
            </StatutBadgeContainer>
          )}
          {isMoreInfosOpened && (
            <>
              <Gap $height={1} />
              <QuestionsView questions={questions} />
              {profileId != import.meta.env.VITE_CYNO_STAFF_PROFILE_ID && (
                <>
                  <Gap $height={1} />
                  <MoreButton profileId={profileId} />
                </>
              )}
            </>
          )}
        </MainContainerOvl>
      </div>
    </Column>
  );
}

const MainContainerOvl = styled(MainContainer)`
  border: none;
  position: relative;
`;

const Image = styled.img`
  border-radius: 30px;
  width: 100%;
  aspect-ratio: 1.2;
  object-fit: cover;
`;
